export default "__VITE_ASSET__RK770kfi__"